import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/mixpanelTracking';

/**
 * Hook to automatically track page views when routes change
 * This ensures every page visit is tracked with actual page names
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    trackPageView();
  }, [location]);
};

export default usePageTracking;
